<template>
	<div
		class="projects-popover-skeleton"
		:aria-label="$t('spa__general.loading')"
	>
		<div class="projects-popover-skeleton__header">
			<SuiSkeleton width="6.25rem" />
			<SuiSkeleton
				v-for="index in 2"
				:key="index"
				width="6.25rem"
				class="projects-popover-skeleton__row-item"
			/>
		</div>

		<div
			class="projects-popover-skeleton__project projects-popover-skeleton__project--with-border"
		>
			<div class="projects-popover-skeleton__project-wrapper">
				<SuiIcon
					class="projects-popover-skeleton__project-icon"
					name="icon-briefcase-filled-16"
					fill="#F0F3FA"
				/>
				<div class="projects-popover-skeleton__project-details">
					<SuiSkeleton width="19.75rem" />
					<SuiSkeleton width="14.75rem" />
				</div>
			</div>

			<SuiSkeleton
				width="6.25rem"
				class="projects-popover-skeleton__row-item"
			/>

			<div class="projects-popover-skeleton__total">
				<SuiSkeleton width="6.25rem" />
				<SuiSkeleton width="4.625rem" />
			</div>
		</div>

		<div class="projects-popover-skeleton__project">
			<div class="projects-popover-skeleton__project-wrapper">
				<SuiIcon
					class="projects-popover-skeleton__project-icon"
					name="icon-briefcase-filled-16"
					fill="#F0F3FA"
				/>
				<div class="projects-popover-skeleton__project-details">
					<SuiSkeleton width="19.75rem" />
					<SuiSkeleton width="14.75rem" />
				</div>
			</div>

			<SuiSkeleton
				width="6.25rem"
				class="projects-popover-skeleton__row-item"
			/>

			<div class="projects-popover-skeleton__total">
				<SuiSkeleton width="6.25rem" />
				<SuiSkeleton width="4.625rem" />
			</div>
		</div>

		<div class="projects-popover-skeleton__footer">
			<div class="projects-popover-skeleton__footer-wrapper">
				<SuiSkeleton width="19rem" />
				<SuiSkeleton width="14.75rem" />
			</div>
			<SuiSkeleton
				v-for="index in 2"
				:key="index"
				width="6.25rem"
				class="projects-popover-skeleton__row-item"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { SuiIcon, SuiSkeleton } from '@developers/scoro-ui';
</script>

<style lang="scss" scoped>
%grid-layout {
	display: grid;
	grid-template-columns: minmax(14rem, 1fr) repeat(2, 10rem);
	gap: 3rem;
}

.projects-popover-skeleton {
	&__header {
		@extend %grid-layout;

		padding: 2.5rem 2.5rem 1.5rem;
		border-bottom: 1px solid $neutral-20;
	}

	&__row-item {
		place-self: flex-start end;
	}

	&__project {
		@extend %grid-layout;

		padding: 2rem 0;
		margin: 0 2.5rem;

		&--with-border {
			border-bottom: 1px solid $neutral-20;
		}
	}

	&__project-wrapper {
		display: flex;
		gap: 1rem;
	}

	&__project-icon {
		margin-top: -0.5rem;
	}

	&__footer {
		@extend %grid-layout;

		padding: 2rem 2.5rem;
		border-top: 1px solid $neutral-20;
	}

	&__project-details,
	&__total,
	&__footer-wrapper {
		display: flex;
		flex-direction: column;
		gap: 1.25rem;
	}

	&__total {
		align-items: flex-end;
	}
}
</style>
